module.exports = __webpack_public_path__ + "media/12.2d649c02.mp3";